import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Control, Form } from 'react-redux-form';
import { Checkbox, Col, FormGroup, Row } from 'react-bootstrap';
import RequiredInput from '../../../../components/common/form/elements/required-input';
import ArrowButton from '../../../../components/common/button-arrow';
import LayoutContainer from '../../../../components/layout/layout-container/index';
import { saveUserGroup, updateUserGroup } from '../../../../actions/usergroups';

class EditUserGroupForm extends Component {
  state = {};

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  onSubmit = (payLoad) => {
    if (this.props.userGroup.id) {
      this.props.dispatch(actions.submitFields('deep.admin_usergroup', updateUserGroup(this.props.userGroup.id, payLoad)));
    } else {
      this.props.dispatch(actions.submitFields('deep.admin_usergroup', saveUserGroup(payLoad)));
    }
  };

  generatePermissions = permissions => (permissions.length > 0) && (
    <FormGroup className="permission-block">
      {
        permissions.map(perm => (
          <LayoutContainer key={perm.id}>
            <div className={perm.children.length ? 'has-children' : 'no-children'}>
              <Control.checkbox
                component={Checkbox}
                model={`.permission_ids[${perm.id}].checked`}
              >
                {perm.name}
              </Control.checkbox>
              {this.generatePermissions(perm.children)}

            </div>
          </LayoutContainer>
        ))
      }
    </FormGroup>
  );

  render() {
    return (
      <Form model="deep.admin_usergroup" onSubmit={this.onSubmit}>
        <Row>
          <Col lg={12}>
            <RequiredInput
              label="Name"
              model=".name"
              placeholder="Name"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            {
              this.props.userGroup && this.generatePermissions(this.props.userGroup.attributes.permissions)
            }
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrowButton
              className="pull-right"
              color="grey"
              disabled={!this.props.formValid}
            >
              Save
            </ArrowButton>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  modelPermissions: state.deep.admin_usergroup.permission_ids,
  userGroup: state.userGroups.userGroup,
  fetched: state.userGroups.fetched,
  fetching: state.userGroups.fetching,
  formValid: state.deep.forms.admin_usergroup.$form.valid,
});

export default connect(mapStateToProps)(EditUserGroupForm);



// WEBPACK FOOTER //
// ./src/components/admin/usergroups/edit/usergroup-edit-form.jsx